import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, LOCALE_ID } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { FormsModule } from '@angular/forms'
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import { progressInterceptor, NgProgressHttp } from 'ngx-progressbar/http'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { StoreModule } from '@ngrx/store'
import { reducers } from './store/reducers'
import { OnlineStatusModule } from 'ngx-online-status'

/***
 * Locale Registration
 */
import { registerLocaleData } from '@angular/common'
import { default as localeEn } from '@angular/common/locales/en'
import { NZ_I18N, NZ_DATE_LOCALE, en_US as localeZorro } from 'ng-zorro-antd/i18n'
import { enUS } from 'date-fns/locale'
import { CookiesConsentComponent } from './components/cookies-consent/cookies-consent.component'
import { CookiesConsentOptionsModalComponent } from './components/cookies-consent/cookies-consent-options-modal/cookies-consent-options-modal.component'
import { SharedModule } from './shared.module'
import { NgProgressbar } from 'ngx-progressbar'

const LOCALE_PROVIDERS: any[] = [
  { provide: LOCALE_ID, useValue: 'en' },
  { provide: NZ_I18N, useValue: localeZorro },
  { provide: NZ_DATE_LOCALE, useValue: enUS },
]
registerLocaleData(localeEn, 'en')

@NgModule({
  declarations: [AppComponent, CookiesConsentComponent, CookiesConsentOptionsModalComponent],
  // providers: [...LOCALE_PROVIDERS, { provide: SETTINGS, useValue: {} }],
  bootstrap: [AppComponent],
  exports: [CookiesConsentOptionsModalComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule.forRoot(),
    /**
     * NgRx Store
     */
    StoreModule.forRoot(reducers),
    // StoreRouterConnectingModule.forRoot(),
    /**
     * Routing Module
     */
    AppRoutingModule,
    OnlineStatusModule,
    SharedModule,
    NgProgressbar,
    NgProgressHttp,
  ],
  providers: [
    ...LOCALE_PROVIDERS,
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(withInterceptors([progressInterceptor])),
  ],
})
export class AppModule {}
